// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mount-headers,.mount-rows{display:grid;grid-template-columns:42% 42% 5% auto;grid-gap:1.75%;margin-bottom:10px;align-items:center}.mount-headers .remove BUTTON,.mount-rows .remove BUTTON{padding:0}.mount-headers{color:var(--input-label)}", ""]);
// Exports
module.exports = exports;
